import { formHeaderClassNames } from "@/shared/constants/customStyleSets";

export function SuccessMessage() {
	return (
		<div className="text-center">
			<h2 className={formHeaderClassNames}>Success!</h2>

			<p className="mb-4 text-lg">
				You are ready to use{" "}
				<span className="font-bold text-gold" data-testid="landing-page-link">
					EPSMomentum.com.
				</span>
			</p>
		</div>
	);
}
